import { render, staticRenderFns } from "./BeneficioExcluido.vue?vue&type=template&id=3620f324&scoped=true&"
import script from "./BeneficioExcluido.vue?vue&type=script&lang=js&"
export * from "./BeneficioExcluido.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioExcluido.vue?vue&type=style&index=0&id=3620f324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620f324",
  null
  
)

export default component.exports